import React from 'react';

import EventsReport from '../../components/events/EventsReport';
import PageLayout from '../../components/layout/PageLayout';

const EventsPage = () => {
  return (
    <PageLayout>
      <EventsReport />
    </PageLayout>
  );
};

export default EventsPage;
